import { render, staticRenderFns } from "./PricingList.vue?vue&type=template&id=1a7a7f8c&"
import script from "./PricingList.vue?vue&type=script&lang=js&"
export * from "./PricingList.vue?vue&type=script&lang=js&"
import style0 from "./PricingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports